import { Heading, RangePicker, Select } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import styled from 'styled-components'

export const SpacedColumnHeader = styled.div`
  margin-left: 8px;
`

export const YearText = styled(Heading)`
  color: ${({ theme }) => theme.color.neutral.color4};
`

export const BaseText = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color3};
`

export const YearContainer = styled.div`
  display: flex;
  margin-bottom: -12px;
`

export const StyledRangePicker = styled(RangePicker)`
  ${({ theme }) => theme.mediaQueries.tabletDown} {
    width: 65%;
  }
  ${({ theme }) => theme.mediaQueries.mobileDown} {
    width: 100%;
  }
`

export const StyledSelect = styled(Select)`
  ${({ theme }) => theme.mediaQueries.mobileDown} {
    width: 100%;
  }
  min-width: 280px;
`
